module.exports = __webpack_public_path__ + "img/UI_common_framelabelBYB_02_54366dbf2.png";